import { useCallback } from 'react';
import * as xlsx from 'xlsx';

export const useDownload = () => {
  const downloadXlsx = useCallback((json: any, name: string, page: string | null = null) => {
    const workbook = xlsx.utils.book_new();
    const worksheet = xlsx.utils.json_to_sheet(json);
    xlsx.utils.book_append_sheet(workbook, worksheet, page ?? undefined);
    xlsx.writeFile(workbook, name + '.xlsx');
  }, []);

  const downloadXlsxMultiSheet = useCallback(
    (
      json: {
        sheets: Array<{
          name: string;
          data: Array<any>;
        }>;
      },
      name: string,
      _page: string | null = null,
    ) => {
      const workbook = xlsx.utils.book_new();
      json.sheets.forEach((sheet) => {
        const worksheet = xlsx.utils.json_to_sheet(sheet.data);
        xlsx.utils.book_append_sheet(workbook, worksheet, sheet.name);
      });
      xlsx.writeFile(workbook, name + '.xlsx');
    },
    [],
  );

  return {
    downloadXlsx,
    downloadXlsxMultiSheet,
  };
};
